// AVB3: standalone Products section (top-level route). Reuses the billing UI. Role-gated.
import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AvBilling from './AvBilling';

const ALLOWED = ['admin', 'md', 'accounts']; // who can open Products

export default function AvProducts() {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (user && !ALLOWED.includes(user.role)) return <Navigate to="/dashboard" />;
  return <AvBilling onBack={() => navigate('/dashboard')} />;
}
